document.addEventListener("DOMContentLoaded", function () {
  const zoomButtons = document.querySelectorAll('.swiper-slide #zoom-button');

  zoomButtons.forEach(button => {
    // Avoid duplicate binding
    if (button.dataset.bound === 'true') return;

    button.addEventListener('click', function () {
      const slide = button.closest('.swiper-slide');
      const image = slide.querySelector('img');
      if (!image) return;

    const imageUrl = image.getAttribute('src');

    // Create the modal container
    const zoomModal = document.createElement("div");
    zoomModal.style.cssText = `
        position: fixed;
        top: 0; left: 0;
        width: 100vw; height: 100vh;
        background: rgba(0,0,0,0.9);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
    `;

    // Create the zoomed image
    const zoomedImage = document.createElement("img");
    zoomedImage.src = imageUrl;
    zoomedImage.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        border-radius: 12px;
        box-shadow: 0 0 15px rgba(0,0,0,0.5);
    `;

    // Create the close button
    const closeButton = document.createElement("button");
    closeButton.textContent = "×";
    closeButton.setAttribute("aria-label", "Close");
    closeButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 30px;
        width: 40px;
        height: 40px;
        font-size: 26px;
        font-weight: bold;
        color: black;
        background-color: #f9f6f6;
        border: 1px solid #183F86;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 10px rgba(0,0,0,0.5);
        transition: background-color 0.3s ease, transform 0.2s ease;
        z-index: 10001;
    `;

    // Close the modal when clicking the close button
    closeButton.addEventListener("click", () => {
        document.body.removeChild(zoomModal);
    });

    // Append elements to modal and then to body
    zoomModal.appendChild(zoomedImage);
    zoomModal.appendChild(closeButton);
    document.body.appendChild(zoomModal);


    zoomModal.addEventListener("click", () => {
        document.body.removeChild(zoomModal);
    });
    });

    button.dataset.bound = 'true';
  });
});
